import './index.css';

export default function Loading() {
    return (
        <div id="loading-bar" />
    );
}